import { CellInformation, ScriptLinkItem } from ".";

export class ExternalScriptExecuteResult {
  isComplete: boolean;
  isCancel: boolean;
  name: string;
  values: CellInformation[];
  compressedCsvText: string;
  scriptLinkResults: ScriptLinkItem[];
}
